import {compareAsc} from 'date-fns';

import {BillData} from 'domain/usecases';
import {BillStatusEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';

const useSortBills = (bills: BillData[]) => {
	const sortByStatus = (a: BillData, b: BillData) => {
		if (a.status === BillStatusEnum.IN_NEGOTIATION) {
			return -1;
		}
		if (b.status === BillStatusEnum.IN_NEGOTIATION) {
			return 1;
		}

		if (a.status === BillStatusEnum.EXPIRED) {
			return -1;
		}
		if (b.status === BillStatusEnum.EXPIRED) {
			return 1;
		}

		if (a.status === BillStatusEnum.OPEN) {
			return -1;
		}

		if (b.status === BillStatusEnum.OPEN) {
			return 1;
		}
		return 0;
	};
	const sortByDateBills = (a: BillData, b: BillData) => {
		const dateA = a?.linhaDigitavel?.dtVencimento
			? new Date(
					formatDateString(a?.linhaDigitavel?.dtVencimento, 'dd/MM/yyyy', 'yyyy-MM-dd'),
				)
			: 0;
		const dateB = b?.linhaDigitavel?.dtVencimento
			? new Date(
					formatDateString(b?.linhaDigitavel?.dtVencimento, 'dd/MM/yyyy', 'yyyy-MM-dd'),
				)
			: 1;

		return compareAsc(dateB, dateA);
	};

	const sortedByDate = bills.toSorted(sortByDateBills);

	return sortedByDate.toSorted(sortByStatus);
};

export {useSortBills};
